import * as requestFromServer from "./organizationFileCrud";
import { organizationFileSlice, callTypes } from "./organizationFileSlice";
import { actions as auth } from "../../Auth/_redux/authRedux";
import { toastOption } from "../../../../_metronic/_helpers/ToastHelpers";
import { toast } from "react-toastify";

const { actions } = organizationFileSlice;

export const fetchOrganizationFiles = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findOrganizationFile(queryParams)
    .then(response => {
      const {
        data: { total_items, items }
      } = response.data;
      dispatch(actions.organizationFilesFetched({ total_items, items }));
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchOrganizationFile = id => dispatch => {
  if (!id) {
    return dispatch(
      actions.organizationFileFetched({ organizationFileForEdit: undefined })
    );
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getOrganizationFileById(id)
    .then(response => {
      const { data: organizationFile } = response.data;
      dispatch(
        actions.organizationFileFetched({
          organizationFileForEdit: organizationFile
        })
      );
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createOrganizationFile = organizationFile => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createOrganizationFile(organizationFile)
    .then(response => {
      dispatch(actions.organizationFileReload);
      return response.data;
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      toast.error(error, toastOption);
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const deleteOrganizationFile = organizationFile => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteOrganizationFile(organizationFile)
    .then(response => {
      dispatch(actions.organizationFileReload);
      return response.data;
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const updateOrganizationFile = organizationFile => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateOrganizationFile(organizationFile)
    .then(response => {
      dispatch(actions.organizationFileReload);
      return response.data;
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const updateOrgOwnerUser = payload => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateOrgOwnerUser(payload)
    .then(response => {
      dispatch(actions.organizationFileReload);
      return response.data;
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchOrganization = () => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getOrganization()
    .then(response => {
      const { data } = response;
      dispatch(
        actions.organizationFetched({
          organizationForEdit: data
        })
      );
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
